const holiday_management = {
    'zh-tw': "年度假日管理",
    en: "",
    children: {
        detail: {
            'zh-tw': "詳細資訊",
            en: "",
            children: {

            }
        }
    }
}

const language_reservation_registration_and_space_management = {
    'zh-tw': "座位預約管理",
    en: "",
    children: {
        holiday_management: {
            ...holiday_management
        },

    }

}



export {
    language_reservation_registration_and_space_management
}